class LocalizationForm extends HTMLElement {
  select: HTMLSelectElement | null;
  form: HTMLFormElement | null;

  constructor() {
    super();
    this.select = this.querySelector('select[name="country_code"]');
    this.form = this.querySelector("form.localization-form");
    this.select?.addEventListener("change", this.submitForm.bind(this));
  }

  submitForm() {
    this.form?.submit();
  }
}

customElements.define("localization-form", LocalizationForm);
